import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { CONF_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { confOptions } from './configoptions';
import { Observable, catchError, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'ubs-configurations',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./configurations.component.scss']
})
export class ConfigurationsComponent extends BaseComponentConfig {
  /* options:ConfigOptions = {
    name:"",
    title:"Configurations Component",
    listForm:new OfbizList({
      listType:"grid",
      fieldFormLocation:"local",
      listFormName:"EditProductConfigItems",
      listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
      columnFields:this.getFields("EditProductConfigItems",CONF_FORMS),
      columnFieldTitles:this.getColumnFieldTitles("EditProductConfigItems",CONF_FORMS),
      remoteFormData:{
        formData:{
          formName:"EditProductConfigItems",
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          listType:"grid",
          viewIndex:1,
        },
        appContext:"catalog",
        parameters:{"productCategoryId":"CATALOG1_SEARCH"}
      },
      emptyListMessage:"No products found.  Please create new or add existing."
    }),
    addForm:new OfbizForm({
      local:true,
      formName:"EditProductConfigItem",
      formLocation:"component://kwikstore/widget/ConfigForms.xml",
      fields:this.getFields("EditProductConfigItem",CONF_FORMS),
      targets:this.getTargets("EditProductConfigItem",CONF_FORMS),
      titleDescriptionField:this.getTitleDescriptionField("EditProductConfigItem",CONF_FORMS),
      idFieldName:this.getIdFieldName("EditProductConfigItem",CONF_FORMS),
      appContext:"catalog"
    }),
    findForm:new OfbizForm({}),
    breadCrumbData:{
      displayPrefix:"Configuration Items",
        label:"",
        level:1,
        selectedValue:{
          "event":"list",
          "type":"EditProductConfigItems",
          "data":{
            formData:{
              listType:"grid",
              //formName:"ListProducts",
              formName:"EditProductConfigItems",
              //formLocation:"component://product/widget/catalog/ProductForms.xml",
              formLocation:"component://kwikstore/widget/ConfigForms.xml",
            },
            "endPoint":"",
            //"parameters":{"productCategoryId":"","noConditionFind":"Y"}
            //"parameters":{"productCategoryId":""}
          }
        },
        addFormText:"Create Product",
        editFormText:"Update Product"
    },
    actions:[],
    settings:[],
    relations:[
      {
        title:"Config Options",
        addContainerTitle:"Add a configuration option",
        listContainerTitle:"Configuration Options",
        listFormName:"ProductConfigOptionList",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listFormName:"ProductConfigOptionList",
          listType:"grid",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:this.getFields("ProductConfigOptionList",CONF_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("ProductConfigOptionList",CONF_FORMS),
          appContext:"catalog",
          emptyListMessage:"No configuration options found.  Please add existing or create new"
        }),
        addFormName:"CreateConfigOption",
        addForm:new OfbizForm({
          local:true,
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          formName:"CreateConfigOption",
          fields:this.getFields("CreateConfigOption",CONF_FORMS),
          appContext:"catalog"
        })
      },
      {
        title:"Content",
        addContainerTitle:"Add Content to Config Item Content",
        listContainerTitle:"Config Item Content List",
        listFormName:"EditProductConfigItemContent",
        addFormName:"AddProductConfigItemContentAssoc",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"EditProductConfigItemContent",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:this.getFields("EditProductConfigItemContent",CONF_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditProductConfigItemContent",CONF_FORMS),
          appContext:"catalog",
          emptyListMessage:"No content found for this configuration item."
        }),
        addForm:new OfbizForm({
          local:true,
          formName:"AddProductConfigItemContentAssoc",
          formLocation:"component://kwikstore/widget/ConfigForms.xml",
          fields:this.getFields("AddProductConfigItemContentAssoc",CONF_FORMS),
          appContext:"catalog"
        })
      },
      {
        title:"Products",
        addContainerTitle:"",
        listContainerTitle:"Config Item Product List",
        listFormName:"ListProductConfigItem",
        addFormName:"",
        keyMap:{fieldName:"configItemId"},
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"ListProductConfigItem",
          listFormLocation:"component://kwikstore/widget/ConfigForms.xml",
          columnFields:this.getFields("ListProductConfigItem",CONF_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("ListProductConfigItem",CONF_FORMS),
          appContext:"catalog",
          emptyListMessage:"No products associated with this configuration item"
        })
      }
    ]
  } */
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private http:HttpClient) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(confOptions);
  }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
    let menuItems:NbMenuItem[] = [
      {title:"List Configurations",icon:"list-outline",link:"/admin/configurations"},
      {title:"New Configuration",icon:"plus-outline"},
      {title:"Recent Configurations",group:true,icon:"grid-outline"}
    ];
    this.getConfigurations(this.baseUrl).subscribe(resp => {
      let configurations:any[] = [];
      let message = resp["successMessage"];
      console.log(resp)
      if(message == "OK"){
        let data = resp["data"];
        let formData = data["formData"];
        let rows:any[] = formData.rows; 
        rows.forEach((row:any[]) => {
          let configuration:any = {};
          row.forEach(field => {
            for(let[k,v] of Object.entries(field)){
              configuration[k] = v;
            }
          })
          configurations.push(configuration);
        })
        if(configurations.length > 0){
          let _menuItems = this.createMenuItems(configurations);
          console.log(_menuItems);
          menuItems = menuItems.concat(_menuItems);
        } 
      }
      this.menuService.addItems(menuItems,menuTag)
    })

  }
  getConfigurations(baseUrl:string):Observable<any>{
    let url:string = baseUrl+'widgets/grid/value/EditProductConfigItems?location=component://kwikstore/widget/ConfigForms.xml&productCategoryId=CATALOG1_SEARCH&noConditionFind=Y';
    return this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => resp))
  }

  createMenuItems(configurations:any[]):NbMenuItem[]{
    let menuItems:NbMenuItem[] = [];
    configurations.forEach((configuration,i) => {
      let configItemId = configuration["configItemId"];
      let menuItem:NbMenuItem = {title:configuration["configItemName"]};
      menuItem.children = [
        {
          title:"Edit Configuration",
          link:"/admin/configurations/configuration/"+configItemId,
          icon:"edit-outline",
          data:{
            event:"edit",
            type:"EditProductConfigItem",
            data:{
              formData:{
                formName:"EditProductConfigItem",
                formLocation:"component://kwikstore/widget/ConfigForms.xml"
              },
              appContext:"catalog",
              parameters:{configItemId:configItemId}
            }
          }
        },
        {
          title:"Config Options",
          link:"/admin/configurations/configuration/"+configItemId+"/config-options",
          icon:"edit-outline",
          data:{
            event:"relate",
            type:"Config Options",
          }
        },
        {
          title:"Content",
          link:"/admin/configurations/configuration/"+configItemId+"/content",
          icon:"edit-outline",
          data:{
            event:"relate",
            type:"Content",
          }
        },
        {
          title:"Products",
          link:"/admin/configurations/configuration/"+configItemId+"/products",
          icon:"edit-outline",
          data:{
            event:"relate",
            type:"Products",
          }
        }
      ]
      if(i < 6){
        menuItems.push(menuItem);
      }
    })
    return menuItems;
  }

}
